import { useCallback, useEffect, useRef, useState } from "react";

const useOverflow = (dependencies: any[] = [], isVertical?: boolean) => {
    const ref = useRef<any>(null);

    const [isOverflowing, setIsOverflowing] = useState(false);

    const checkOverflow = useCallback(() => {
        const node = ref.current;

        if (node) {
            const hasOverflow = isVertical
                ? node.scrollHeight > node.clientHeight
                : node.scrollWidth > node.clientWidth;

            setIsOverflowing(hasOverflow);
        }
    }, [isVertical]);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        checkOverflow();

        const observer = new ResizeObserver(checkOverflow);
        observer.observe(node);

        window.addEventListener("resize", checkOverflow);

        return () => {
            observer.disconnect();
            window.removeEventListener("resize", checkOverflow);
        };

        // eslint-disable-next-line
    }, [checkOverflow, ...dependencies]);

    return { ref, isOverflowing };
};

export { useOverflow };
